import { ACTIVITY_PAGE, ACTIVITY_TYPE, MANAGEMENT_PAGE, MANAGEMENT_TYPE } from "../Visitors";

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('locale-visitors-state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const getPersistableState = (moduleState) => {
    try {
        return {
            [ACTIVITY_PAGE]: {
                [ACTIVITY_TYPE.SIGNED_IN]: {
                    perPage: moduleState[ACTIVITY_PAGE][ACTIVITY_TYPE.SIGNED_IN].perPage,
                    page: moduleState[ACTIVITY_PAGE][ACTIVITY_TYPE.SIGNED_IN].page
                },
                [ACTIVITY_TYPE.SIGNED_OUT]: {
                    perPage: moduleState[ACTIVITY_PAGE][ACTIVITY_TYPE.SIGNED_OUT].perPage,
                    page: moduleState[ACTIVITY_PAGE][ACTIVITY_TYPE.SIGNED_OUT].page,
                },
                [ACTIVITY_TYPE.ALL]: {
                    perPage: moduleState[ACTIVITY_PAGE][ACTIVITY_TYPE.ALL].perPage,
                    page: moduleState[ACTIVITY_PAGE][ACTIVITY_TYPE.ALL].page,
                }
            },
        };

    } catch {
        return {};
    }
}
